import { render, staticRenderFns } from "./ToolbarLink.vue?vue&type=template&id=24e8f001&scoped=true&"
import script from "./ToolbarLink.vue?vue&type=script&lang=js&"
export * from "./ToolbarLink.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarLink.vue?vue&type=style&index=0&id=24e8f001&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e8f001",
  null
  
)

export default component.exports